export type StarGender = "男" | "女";

export interface Star {
  id: string;
  name: string;
  avatar: string;
  gender: StarGender;
  birth: string;
  era: string;
  active: string;
  tags: string[];
  intro: string;
}

export const stars: Star[] = [
  {
    id: "shen-yi-zhou",
    name: "沈亦舟",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20calm%20confident%20asian%20male%20actor%20in%20his%20late%20thirties%20wearing%20a%20dark%20turtleneck%2C%20studio%20lighting%20with%20deep%20navy%20gray%20background%2C%20minimal%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-01&orientation=squarish",
    gender: "男",
    birth: "1985.03",
    era: "80后",
    active: "一线主演",
    tags: ["导演", "悬疑", "剧情"],
    intro: "沈亦舟是朝桐光签约的核心创作者之一，兼具演员与导演身份。他以克制而富有张力的表演著称，擅长刻画内心复杂的角色，近年来多次以导演身份交出高质量作品。",
  },
  {
    id: "su-wan-ning",
    name: "苏晚宁",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20an%20elegant%20asian%20female%20actress%20in%20her%20early%20thirties%20with%20soft%20waves%20hair%20and%20a%20beige%20blazer%2C%20studio%20lighting%20with%20muted%20blue%20gray%20background%2C%20minimal%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-02&orientation=squarish",
    gender: "女",
    birth: "1990.08",
    era: "90后",
    active: "一线主演",
    tags: ["悬疑", "古装", "剧情"],
    intro: "苏晚宁以细腻的表演和极强的角色可塑性受到业内关注。她既能驾驭冷峻的刑侦角色，也能演绎温婉的古装人物，是朝桐光近年多部重点作品的女主角。",
  },
  {
    id: "jiang-mu-ci",
    name: "江暮辞",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20mature%20asian%20male%20actor%20in%20his%20forties%20with%20short%20graying%20hair%20and%20a%20dark%20coat%2C%20studio%20lighting%20with%20deep%20blue%20background%2C%20dignified%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-03&orientation=squarish",
    gender: "男",
    birth: "1978.11",
    era: "70后",
    active: "资深戏骨",
    tags: ["古装", "历史", "正剧"],
    intro: "江暮辞是业界公认的资深演员，三十余年表演生涯塑造了众多经典人物。他台词功底深厚，气场沉稳，在《山海寻踪》《风起敦煌》等作品中贡献了教科书级别的表演。",
  },
  {
    id: "lin-zhi-xia",
    name: "林知夏",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20young%20fresh%20asian%20female%20actress%20in%20her%20mid%20twenties%20with%20long%20straight%20hair%20and%20a%20white%20shirt%2C%20bright%20soft%20studio%20lighting%20with%20light%20blue%20gray%20background%2C%20minimal%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-04&orientation=squarish",
    gender: "女",
    birth: "1995.05",
    era: "95后",
    active: "上升期",
    tags: ["奇幻", "青春", "冒险"],
    intro: "林知夏是朝桐光近年重点培养的新生代演员。她外形清新、表演自然，在奇幻与青春题材中展现出不俗的灵气，被媒体称为“最有潜力的新面孔”。",
  },
  {
    id: "gu-cheng-yu",
    name: "顾承宇",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20sharp%20featured%20asian%20male%20actor%20in%20his%20early%20forties%20wearing%20a%20dark%20shirt%2C%20dramatic%20studio%20lighting%20with%20deep%20navy%20background%2C%20intense%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-05&orientation=squarish",
    gender: "男",
    birth: "1982.02",
    era: "80后",
    active: "一线主演",
    tags: ["犯罪", "谍战", "动作"],
    intro: "顾承宇以硬朗的形象和富有层次的反派/正派演绎闻名。他在《雾都迷光》《暗涌》《代号·北极星》中塑造了多个深入人心的角色，是犯罪与谍战题材的常客。",
  },
  {
    id: "bai-lu",
    name: "白露",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20warm%20mature%20asian%20female%20actress%20in%20her%20late%20thirties%20with%20a%20soft%20updo%20and%20a%20light%20gray%20knit%2C%20soft%20studio%20lighting%20with%20muted%20blue%20background%2C%20elegant%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-06&orientation=squarish",
    gender: "女",
    birth: "1988.09",
    era: "80后",
    active: "实力派",
    tags: ["家庭", "年代", "文艺"],
    intro: "白露擅长演绎内敛而坚韧的女性角色，表演真挚而不着痕迹。她在《归途列车》《城南旧巷》中的表现被誉为“最会演母亲的演员”，情感层次极为丰富。",
  },
  {
    id: "lu-yu",
    name: "陆屿",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20clean%20cut%20young%20asian%20male%20actor%20in%20his%20early%20thirties%20with%20short%20hair%20and%20a%20navy%20sweater%2C%20bright%20studio%20lighting%20with%20light%20gray%20blue%20background%2C%20modern%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-07&orientation=squarish",
    gender: "男",
    birth: "1993.06",
    era: "90后",
    active: "上升期",
    tags: ["青春", "爱情", "动作"],
    intro: "陆屿是朝桐光新生代男演员代表，形象阳光、戏路宽泛。他先后出演《山海寻踪》《盛夏未央》《第七封信》，在口碑与热度之间找到了很好的平衡。",
  },
  {
    id: "wen-yi-ning",
    name: "温以宁",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20gentle%20asian%20female%20actress%20in%20her%20late%20twenties%20with%20shoulder%20length%20hair%20and%20a%20cream%20blouse%2C%20soft%20warm%20studio%20lighting%20with%20muted%20blue%20background%2C%20tender%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-08&orientation=squarish",
    gender: "女",
    birth: "1997.12",
    era: "95后",
    active: "上升期",
    tags: ["爱情", "科幻", "青春"],
    intro: "温以宁以温柔而有辨识度的气质受到观众喜爱。她在《海底的星空》《第七封信》《盛夏未央》中塑造的角色细腻动人，是朝桐光明日之星的代表人物。",
  },
  {
    id: "han-jing-xuan",
    name: "韩景轩",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20veteran%20asian%20male%20actor%20in%20his%20fifties%20with%20gray%20hair%20and%20a%20dark%20jacket%2C%20dignified%20studio%20lighting%20with%20deep%20navy%20background%2C%20classic%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-09&orientation=squarish",
    gender: "男",
    birth: "1975.01",
    era: "70后",
    active: "资深戏骨",
    tags: ["家庭", "文艺", "正剧"],
    intro: "韩景轩是朝桐光的元老级演员，舞台与银幕经验丰富。他的表演沉稳厚重，一句话、一个眼神都自带故事，是剧组公认的“定海神针”。",
  },
  {
    id: "ye-qing-huan",
    name: "叶清欢",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20charming%20asian%20female%20actress%20in%20her%20early%20thirties%20with%20styled%20short%20hair%20and%20a%20dark%20jacket%2C%20moody%20studio%20lighting%20with%20deep%20blue%20gray%20background%2C%20modern%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-10&orientation=squarish",
    gender: "女",
    birth: "1992.04",
    era: "90后",
    active: "实力派",
    tags: ["文艺", "剧情", "爱情"],
    intro: "叶清欢气质独特，擅长演绎带有棱角的都市女性。她在《归途列车》《第七封信》中的表演克制而有力量，被评价为“最有质感的文艺女演员”。",
  },
  {
    id: "chi-yan",
    name: "池砚",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20composed%20asian%20male%20actor%20in%20his%20mid%20thirties%20with%20short%20dark%20hair%20and%20a%20charcoal%20shirt%2C%20dramatic%20studio%20lighting%20with%20deep%20navy%20background%2C%20intense%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-11&orientation=squarish",
    gender: "男",
    birth: "1989.07",
    era: "80后",
    active: "实力派",
    tags: ["谍战", "犯罪", "历史"],
    intro: "池砚是朝桐光中生代演员中的实力担当，尤以谍战、犯罪题材见长。他的表演节奏精准、情绪收放自如，在《暗涌》《雾都迷光》中贡献了大量高光时刻。",
  },
  {
    id: "xu-tang",
    name: "许棠",
    avatar: "https://readdy.ai/api/search-image?query=portrait%20headshot%20of%20a%20bright%20youthful%20asian%20female%20actress%20in%20her%20early%20twenties%20with%20a%20ponytail%20and%20a%20light%20blue%20cardigan%2C%20fresh%20soft%20studio%20lighting%20with%20pale%20blue%20background%2C%20minimal%20editorial%20style%2C%20high%20detail&width=500&height=500&seq=star-avatar-12&orientation=squarish",
    gender: "女",
    birth: "2000.10",
    era: "00后",
    active: "新人",
    tags: ["青春", "家庭", "年代"],
    intro: "许棠是朝桐光 2023 年签约的新人演员，科班出身、可塑性强。她在《城南旧巷》《盛夏未央》中的自然表演让人眼前一亮，被视为未来可期的新生力量。",
  },
];

export const starGenders = ["全部", "男", "女"];
export const starEras = ["全部", "00后", "95后", "90后", "80后", "70后"];
export const starActiveList = ["全部", "一线主演", "实力派", "资深戏骨", "上升期", "新人"];